import enGbMessages from '../locales/en_GB.json';
import {enGB} from './../../../types/locale';

const GbLang = {
  messages: {
    ...enGbMessages,
  },
  muiLocale: enGB,
  locale: 'en-GB',
};
export default GbLang;
